import React from 'react';
import { useTranslation } from 'react-i18next';
import { frames } from '../../../Styles';
import { PageHeader } from '../../../Components';
import { Pages } from '../../../Navigation/root';

export default function Dashboard() {
  const { t } = useTranslation();

  return (
    <frames.Page_inner>
      <PageHeader topHeader={t(`menuHeaders.${Pages.dashboard}`, {defaultValue: "dashboard"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})} />
      <frames._page_inner_content_scroll>

      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}